"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Legend = function Legend(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  return _react["default"].createElement(LegendElement, _extends({
    className: className
  }, rest), children);
};

Legend.themeProps = {
  legend: {
    name: "LEGEND",
    description: "Legend style",
    type: _themeContants.themePropTypes.style
  }
};

var LegendElement = _styledComponents["default"].legend.withConfig({
  displayName: "Legend__LegendElement",
  componentId: "sc-10p5iw3-0"
})(["font-weight:", ";font-family:", ";font-size:", ";line-height:1.2;padding-bottom:", ";display:block;", ";"], _theming.fontWeight.bold, _theming.fontFamily.body, _theming.font.h5, _theming.spacing.tiny, (0, _theming.applyVariants)(Legend.themeProps.legend));

Legend.defaultProps = {
  className: ""
};
Legend.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string
  /** @component */

};
var _default = Legend;
exports["default"] = _default;